import { Navigate, Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div>
      <h1>ARADIĞINIZ SAYFA BULUNAMADI</h1>
      <br />
      <br />
      <Link to="/" variant="body2">
        Ana Sayfa
      </Link>
    </div>
  );
}
